import { Divider } from '@mui/material';
import CostCenterSettings from './components/CostCenterSettings';

import {
  GridContainerFullWidth,
  GridCompact6
} from 'components/shared/Grid/Grid.components';
import { StyledPaper } from 'components/shared/Paper/StyledPaper.styles';

import {
  MATCH_SETTINGS_GROUP,
  DTR_SETTINGS_GROUP,
  TRAVELCOST_SETTINGS_GROUP,
  ROSTERSTATE_SETTINGS_GROUP
} from './constants';

const Settings = ({ costCenterId }) => {
  return (
    <StyledPaper>
      <GridContainerFullWidth>
        <GridCompact6>
          <CostCenterSettings
            settingsGroup={MATCH_SETTINGS_GROUP}
            costCenterId={costCenterId}
            fullWidth
          />
        </GridCompact6>
        <GridCompact6>
          <CostCenterSettings
            settingsGroup={DTR_SETTINGS_GROUP}
            costCenterId={costCenterId}
            fullWidth
          />
          <Divider sx={{ my: 3 }} />
          <CostCenterSettings
            settingsGroup={TRAVELCOST_SETTINGS_GROUP}
            costCenterId={costCenterId}
            fullWidth
          />
          <Divider sx={{ mt: 3, mb: 6 }} />
          <CostCenterSettings
            settingsGroup={ROSTERSTATE_SETTINGS_GROUP}
            costCenterId={costCenterId}
            fullWidth
          />
        </GridCompact6>
      </GridContainerFullWidth>
    </StyledPaper>
  );
};

export default Settings;
